export default {
	"receiptcreate": {
		"btnReceipt": "หลักฐานการจัดส่ง",
		"electronicReceipt": "หลักฐานการจัดส่งทางอิเลคทรอนิคส์",
		"electronicReceiptStatus": "สถานะของหลักฐานการจัดส่งทางอิเลคทรอนิคส์",
		"electronicReceiptPersonName": "ผู้อัพโหลด ePOD",
		"electronicReceiptDt": "เวลารับแบบอิเลคทรอนิคส์",
		"electronicReceiptCheckedDt": "เวลายืนยัน ePOD",
		"checkedPersonName": "ผู้ตรวจสอบ ePOD",
		"paperyReceipt": "เอกสาร POD",
		"backCheckedStatus": "สถานะของเอกสาร POD",
		"backPersonName": "ผู้อัพโหลด POD",
		"backCheckedPersonName": "ผู้ยืนยัน POD",
		"backCheckedPersonDt": "เวลายืนยัน POD",
		"backConfirmDt": "เวลาที่ได้รับ POD ",
		"mailBackDt": "เวลาที่ตรวจสอบ",
		"expressNo": "หมายเลขการติดตาม",
		"signPersonDt": "เวลาที่ลงนาม",
		"backTabInfo": "ข้อมูล POD",
		"receiptStatusChecked": "ยืนยันแล้ว",
		"checkedReceipt": "ยืนยัน POD",
		"receiptStatusBacked": "การรับ",
		"emailLog": "เนื้อหาอีเมล์ที่ได้รับ",
		"paperyReceiptForShipperConfirm": "การยืนยันการรับของผู้จัดส่ง"
	},
	"receiptemail": {
		"sendEmailTips": "ท่านแน่ใจว่าจะส่งอีเมล์หรือไม่?",
		"receiptWait": "รอ"
	}
}


// WEBPACK FOOTER //
// ./src/lang/th/pages/receipt/receipt.js